import React, { Component, ReactNode } from "react";
import * as Sentry from "@sentry/react"; // Optional: For logging errors to Sentry

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("Error caught by ErrorBoundary: ", error, errorInfo);
    Sentry.captureException(error); // Optional: Log to Sentry
  }

  render() {
    if (this?.state?.hasError) {
      return this?.props?.fallback;
    }

    return this?.props?.children;
  }
}

export default ErrorBoundary;
